<template>
  <!-- 免费药具领取 -->
  <div id="main-page">
    <div id="main-top-content">
      <div id="top-content-msg">
        领取条件：携带身份证领取、每人每月不限领取数量
      </div>
      <div id="screen-input" @click="showPicker">
        <div id="input-test">{{ choiceText }}</div>
        <icon-svg
          slot="prepend"
          :icon-class="'ic_xy_ud'"
          :className="'searchicon'"
        />
      </div>
    </div>
    <div id="main-list-content">
      <div class="list-item" v-for="(item, index) in dataList" :key="index">
        <h4>{{ item.address }}</h4>
        <div class="item-type">领取方式：{{ showMode(item) }}</div>
        <div class="item-time">营业时间：{{ item.time }}</div>
        <div class="item-phone">
          投诉电话：<span>{{ item.complaintCall }}</span>
        </div>
        <div class="item-mode">村镇：{{ item.community }}·{{ item.town }}</div>
        <div class="item-goods">
          <div v-show="item.artificial">{{ item.artificial }}</div>
          <div v-show="item.condom">{{ item.condom }}</div>
          <div v-show="item.oralMedicine">{{ item.oralMedicine }}</div>
          <div v-show="item.injections">{{ item.injections }}</div>
          <div v-show="item.iud">{{ item.iud }}</div>
          <div v-show="item.externalMedication">
            {{ item.externalMedication }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFreeDrugsCommunity, getFreeDrugsList } from "@/api/api";
export default {
  data() {
    return {
      choiceText: "全部",
      column: [{ _id: "全部" }],
      dataList: [],
    };
  },
  created() {
    if (this.$eshimin) {
      this.$eshimin.setTitle({
        title: "免费药具领取",
        onResponse: function (res) {
          console.log("setTitle res:" + res);
        },
      });
    }
    getFreeDrugsCommunity().then((res) => {
      if (res.code == 200) {
        res.data.forEach((item) => {
          this.column.push(item);
        });
      }
    });

    getFreeDrugsList().then((res) => {
      if (res.code == 200) {
        this.dataList = res.data;
      }
    });
  },
  methods: {
    showMode(item) {
      let arry = [];
      if (item.machine) arry.push(item.machine);
      if (item.cost) arry.push(item.cost);
      if (item.claimBox) arry.push(item.claimBox);
      return arry.toString(",");
    },
    showPicker() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: "社区/行政村",
          data: [this.column],
          onSelect: this.selectHandle,
          alias: {
            value: "_id",
            text: "_id",
          },
        });
      }
      this.picker.show();
    },
    selectHandle(selectedVal) {
      this.choiceText = selectedVal.join(",");
      getFreeDrugsList({ community: this.choiceText }).then((res) => {
        if (res.code == 200) {
          this.dataList = res.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
div {
  box-sizing: border-box;
}
#main-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 0;
  background: #f4f6f8;
}
#main-top-content {
  height: 90px;
  background: #fff;
  #top-content-msg {
    height: 40px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    padding-left: 15px;
  }
  #screen-input {
    height: 33px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #979797;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 15px;
    #input-test {
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      padding-left: 10px;
    }
    .searchicon {
      height: 60%;
      display: block;
    }
  }
}
#main-list-content {
  height: calc(100% - 90px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 5px 0;
  .list-item {
    padding: 15px;
    font-size: 0;
    overflow: hidden;
    background: #fff;
    margin: 10px 15px;

    border-radius: 8px;
    h4 {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 24px;
    }
    .item-type {
      margin-top: 5px;
      display: inline-block;
      background: rgba(205, 161, 105, 0.15);
      border-radius: 2px;

      font-size: 13px;
      font-family: SFCompactDisplay-Regular, SFCompactDisplay;
      font-weight: 400;
      color: #cda169;
      padding: 2px 4px 3px 4px;
    }
    .item-time {
      margin-top: 5px;

      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
    }
    .item-phone {
      margin-top: 5px;

      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
      span {
        color: #0882f3;
      }
    }
    .item-mode {
      margin-top: 5px;

      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
    }
    .item-goods {
      margin-top: 20px;
      div {
        background: rgba(76, 186, 147, 0.1);
        border-radius: 2px;

        font-size: 13px;
        font-family: SFCompactDisplay-Regular, SFCompactDisplay;
        font-weight: 400;
        color: #4cba93;
        padding: 2px 4px 3px 4px;
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
